export enum TableMode {
    LandBased = 'LandBased',
    Online = 'Online'
}

export enum WorkerAccessLevel {
    None = 'None',
    Croupier = 'Croupier',
    Supervisor = 'Supervisor'
}

export enum AppPhase {
    WaitingForCroupier = 'WaitingForCroupier',
    WaitingForPlayers = 'WaitingForPlayers',
    NewRoundPreparation = 'NewRoundPreparation',
    BetsOpen = 'BetsOpen',
    BetsClosed = 'BetsClosed',
    DealingCards = 'DealingCards',
    RoundEnd = 'RoundEnd',
    ShoeChange = 'ShoeChange',
    CardBurn = 'CardBurn',
    RoundVoid = 'RoundVoid',
    RoundError = 'RoundError',
    Decision = 'Decision',
    TableClosed = 'TableClosed'
}

export enum DealingSubPhase {
    FaceDown = 0,
    Dealing = 1,
    SideSelectionAnimation = 2,
    LeftSide = 3,
    RightSide = 4
}

export enum SupervisorSubPhase {
    WaitingForSupervisor = 'WaitingForSupervisor',
    GameSelection = 'GameSelection',
    ConfirmGameSelection = 'ConfirmGameSelection',
    ConfirmAction = 'ConfirmAction',
    ActionSelection = 'ActionSelection',
    AddingWorker = 'AddingWorker'
}

export enum DealerAction {
    ShoeChanged = 'ShoeChanged', // Confirm shoe change
    RedrawCards = 'RedrawCards', // Redraw cards (clear current state and enable redrawing)
    CallSupervisor = 'CallSupervisor',
    CompleteRound = 'CompleteRound' // In manual conformation mode button triggers round end (confirmed result)
}

export enum SupervisorAction {
    ContinueGame = 'ContinueGame',
    VoidGame = 'VoidGame', // Voiding game
    FreeHand = 'FreeHand',
    CloseTable = 'CloseTable', // Supervisor action (also set TableClosingRequested)
    ChangeResult = 'ChangeResult', // Supervisor action
    ChangeGame = 'ChangeGame', // Supervisor action
    ChangeShoe = 'ChangeShoe', // As toggle
    AddWorker = 'AddWorker',
    ConfirmAction = 'ConfirmAction'
}

export enum FlagStateType {
    ChatEnabled = 'ChatEnabled',
    SupervisorCalled = 'SupervisorCalled',
    // Supervisor flags only for state
    ResultChangingRequested = 'ResultChangingRequested',
    GameChangingRequested = 'GameChangingRequested',
    TableClosingRequested = 'TableClosingRequested',
    ChangeShoeRequested = 'ChangeShoeRequested',
    FreeHandEnabled = 'FreeHandEnabled',
    HistoryRequested = 'HistoryRequested'
}

export enum DealerAssistTableErrorCode {
    BackendDisconnected = 'BackendDisconnected',
    RoundOpeningFailed = 'RoundOpeningFailed',
    RoundResultSavingFailed = 'RoundResultSavingFailed'
}

export enum NotificationCode {
    AuthenticationFailed = 'AuthenticationFailed',
    AuthenticationSuccess = 'AuthenticationSuccess',
    CroupierChangeInvalidState = 'CroupierChangeInvalidState',
    DuplicateCard = 'DuplicateCard',
    FlagFailed = 'FlagFailed',
    InvalidCard = 'InvalidCard',
    InvalidCroupierId = 'InvalidCroupierId',
    ScannerDisconnected = 'ScannerDisconnected',
    ScannerConnected = 'ScannerConnected',
    ExpectedSupervisor = 'ExpectedSupervisor',
    InvalidDealing = 'InvalidDealing',
    // Frontend only
    ActionFailed = 'ActionFailed',
    CutCardDrawn = 'CutCardDrawn',
    ConnectionClosed = 'ConnectionClosed',
    SecurityDoorOpened = 'SecurityDoorOpened'
}

export enum NotificationSeverity {
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error'
}

export enum GameType {
    Baccarat = 'Baccarat',
    DragonTiger = 'DragonTiger',
    ThreeHeadedDragon = 'ThreeHeadedDragon',
    OpenBaccarat = 'OpenBaccarat',
    OpenDragonTiger = 'OpenDragonTiger'
}
